module.exports = __webpack_public_path__ + "static/media/scholarship2023.e219553d.jpg";